<template>
  <div class="banner" >
    <el-carousel :height="bannerHeight" :interval="5000" arrow="always" v-loading.fullscreen.lock="fullscreenLoading">
      <el-carousel-item  v-for="(item, index) in bannerList" :key="index">
        <img ref="imgH" :src="item.bg" style="width: 100%;" @load="imgLoad">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        bannerList:[
          {
            bg: require('@/asstes/home/home_banner.png')
          },
          {
            bg: require('@/asstes/home/home_banner.png')
          },
          {
            bg: require('@/asstes/home/home_banner.png')
          },
          {
            bg: require('@/asstes/home/home_banner.png')
          },
        ],
        bannerHeight: '',
        fullscreenLoading: false,
      }
    },
    created() {
      this.fullscreenLoading = true;
    },
    mounted() {
      window.addEventListener("resize",() => {
        this.imgLoad();
      });
    },
    destroyed(){
      window.removeEventListener("resize",() => {
        this.imgLoad();
      });
    },
    methods:{
      imgLoad(){
        let that = this
        that.$nextTick(()=>{
          that.bannerHeight = that.$refs.imgH[0].height + 'px';
          if(that.bannerHeight){
            that.fullscreenLoading = false;
          }
        })
      }
    }
  }

</script>

<style lang="less" scoped>
  @media only screen and (max-width: 750px){
    .banner{
      display: none;
    }
  }
  @media only screen and (min-width: 750px){
    .banner{
      /deep/ .el-carousel__button{
        width: 9px;
        height: 9px;
        border-radius: 9px;
      }
      /deep/ .el-carousel__indicator--horizontal{
        padding: 16px 12px;
        box-sizing: border-box;
      }
      /deep/ .el-carousel__indicator.is-active button{
        opacity: 1;
        background-color: #07CFA2;
      }
      /deep/ .el-carousel__indicators--horizontal{
        bottom: 88px;
      }
    }
  }
</style>
